export const profileColors = [
  "bg-darkseagreen",
  "bg-thistle",
  "bg-darkkhaki",
  "bg-blueskydull",
];
